import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

// import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import bannerSale from "../assest/images/banner-img/banner.png";

// flg-img

import flagImg from "../assest/images/car-img/flg.png";

// import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import AOS from "aos";
import "aos/dist/aos.css";

import ImgAdven from "../assest/images/banner-img/separtor.png";
import customerImg from "../assest/images/about-us/customer-img-grp.png";
import leftCar from "../assest/images/bike-rider/Left-Car.png";
import tyre from "../assest/images/bike-rider/Left-Car-tyre.png";
import rightTree from "../assest/images/bike-rider/right.png";

import LightGallery from "lightgallery/react";

// plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import bannerVideo from "../assest/images/banner-video.mp4";

// styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import bgImage from "../assest/images/banner-img/img-three.jpg"; // image import

// faq-imgs

import carImg from "../assest/images/faq-img/Girl-Image.png";
import carImg1 from "../assest/images/faq-img/hotballon-Left.png";
import carImg2 from "../assest/images/faq-img/hotballon-right.png";
import carImg3 from "../assest/images/faq-img/cloud-1.png";
import carImg4 from "../assest/images/faq-img/cloud-2.png";

import whyImg from "../assest/images/car-img/crysta-1.png";

import trekking from "../assest/images/advanger-img/tracking.jpg";
import jeep from "../assest/images/advanger-img/4.jpg";
import camel from "../assest/images/advanger-img/tracking.jpg";
import cycling from "../assest/images/advanger-img/bike.jpg";

import camping from "../assest/images/advanger-img/tracking.jpg";
import biking from "../assest/images/advanger-img/bike.jpg";
import { errorAlert, successAlert } from "../services/sweetAlert";
import L from "leaflet";
import { apiRequest } from "../services/allApi";
import { useLocation } from "react-router-dom";
// import vectorImg from "../assest/images/vector/about-img-bg-vector.svg";
import { Helmet } from "react-helmet-async";
import Loader from "../component/loader.jsx";

const Home = () => {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleBook = (slug) => {
    navigate(`/TourDetail/${slug}`);
  };

  // 1. सबसे पहले Initial State को खाली वैल्यूज के साथ सेट करें
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Tour Inquiry",
    comments: "", // Input field का 'name' attribute यही रखें
    travel_date: "", // Input field का 'name' attribute यही रखें
  });

  // 2. इनपुट बदलने पर स्टेट अपडेट करने के लिए
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // 3. फॉर्म सबमिट करते समय API कॉल
  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    // अगर आपकी API को 'comments' की जगह 'message' नाम से डेटा चाहिए,
    // तो यहाँ उसे बदल कर भेजें:
    const payload = {
      ...formData,
      message: formData.comments, // यहाँ मैपिंग करें
      date: formData.travel_date, // यहाँ मैपिंग करें
    };

    try {
      const res = await apiRequest("home-inquiry", "POST", payload);
      setIsLoading(false);
      if (res?.success) {
        successAlert(res.message);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const [homeData, setHomeData] = useState([]);
  const Home = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("home");
      setIsLoading(false);
      if (res?.success) {
        setHomeData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [galleryData, setGalleryData] = useState([]);

  const Gallery = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("gallery");
      setIsLoading(false);
      if (res?.success) {
        setGalleryData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Gallery();
    Home();
  }, []);

  const [activeSlug, setActiveSlug] = useState("about-us");

  useEffect(() => {
    if (homeData?.cmsPages?.length > 0) {
      setActiveSlug(homeData.cmsPages[0].slug);
    }
  }, [homeData]);

  const activeCMS = homeData?.cmsPages?.find(
    (item) => item.slug === activeSlug,
  );
  useEffect(() => {
    if (homeData?.cmsPages?.length) {
      const aboutExists = homeData.cmsPages.find(
        (item) => item.slug === "about-us",
      );

      // agar about milta hai tabhi set karo
      if (aboutExists) {
        setActiveSlug("about-us");
      } else {
        // fallback: first item open kar do
        setActiveSlug(homeData.cmsPages[0].slug);
      }
    }
  }, [homeData]);
  // why-choose-us

  const features = [
    {
      title: "Trekking",
      desc: "Every step brings you closer to breathtaking nature.",
      img: trekking,
    },

    {
      title: "Jeep",
      desc: "Ride through Ladakh’s challenging terrains.",
      img: jeep,
    },
    {
      title: "Camping",
      desc: "Unplug and unwind under the starry skies.",
      img: camping,
    },
    {
      title: "Biking",
      desc: "Motorbiking that magnifies adventure.",
      img: biking,
    },
    {
      title: "cycling",
      desc: "Ride through Ladakh’s challenging terrains.",
      img: cycling,
    },
    {
      title: "Camel",
      desc: "Unplug and unwind under the starry skies.",
      img: camel,
    },
  ];

  const toggleFAQ = (index) => {
    setActiveFaqIndex(activeFaqIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const [activeCarIndex, setActiveCarIndex] = useState(0);
  const activeCar = homeData?.sliders?.[activeCarIndex];

  const [activeFaqIndex, setActiveFaqIndex] = useState(null);

  const icon = (color) =>
    new L.Icon({
      iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-${color}.png`,
      shadowUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
    });
  const [showMore, setShowMore] = useState(false);

  /* ---------- Locations ---------- */

  /* ---------- Component ---------- */
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>Book Ladakh Tour Packages | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Explore Ladakh tour packages with bike trips, rentals & custom tours in Leh. Book your adventure with Ladakh MotoDrive today!"
        />

        <meta
          name="keywords"
          content="ladakh tour packages, leh ladakh tour, ladakh tour, leh tour packages, ladakh travel packages, ladakh trip cost, ladakh itinerary, ladakh motodrive"
        />

        <link rel="canonical" href="https://ladakhmotodrive.com" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Book Ladakh Tour Packages | Ladakh MotoDrive"
        />
        <meta
          property="og:description"
          content="Explore Ladakh with comfortable car tour packages. Visit Leh, Nubra Valley & Pangong Lake with expert drivers from Ladakh MotoDrive."
        />
        <meta property="og:url" content="https://ladakhmotodrive.com" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Book Ladakh Tour Packages | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="Explore Ladakh with comfortable car tour packages. Visit Leh, Nubra Valley & Pangong Lake with expert drivers from Ladakh MotoDrive."
        />
      </Helmet>
      <section className="home-banner-section home-banner-slider position-relative">
        <video autoPlay muted loop playsInline className="banner-video">
          <source src={bannerVideo} type="video/mp4" />
        </video>

        <div className="banner-content-1">
          <h1>Welcome to Ladakh Motodrive </h1>
          <p>
            We Don’t Just Plan Trips… We Create Mountain Stories.” Feel the cold
            breeze of the Himalayas
          </p>
          <a href="/premium-ladakh-tour-packages" className="btn btn-primary">
            Explore Tour
          </a>
        </div>
      </section>
      <section className="home-destination tour-package-1 ">
        <div className="flag-img-1">
          <img src={flagImg} alt="" />
        </div>

        <div className="container">
          <div className="row">
            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <div
                className="about-content"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {/* TITLE */}
                <div className="section-title mb-40">
                  <span>About Us</span>
                  <h2>Ladakh Based Company</h2>
                </div>

                {/* TABS */}
                <ul className="nav nav-pills" role="tablist">
                  {homeData?.cmsPages
                    ?.filter(
                      (item) =>
                        item.title === "About" ||
                        item.title === "Mission & Vision",
                    )
                    .map((item, index) => (
                      <li className="nav-item" key={item.id}>
                        <button
                          className={`nav-link ${
                            activeSlug === item.slug ? "active" : ""
                          }`}
                          type="button"
                          onClick={() => setActiveSlug(item.slug)}
                        >
                          <i className="bi bi-bullseye me-2"></i>
                          {item.title}
                        </button>
                      </li>
                    ))}
                </ul>

                {/* more about here */}
                <div className="tab-content mt-4">
                  {activeCMS && (
                    <div>
                      {/* <h4>{activeCMS.title}</h4> */}

                      <div
                        dangerouslySetInnerHTML={{
                          __html: activeCMS?.description,
                        }}
                      />
                    </div>
                  )}
                </div>
                {/* TAB CONTENT */}
                <div className="tab-content mt-3">
                  {/* TAB 1 */}

                  {/* TAB 2 */}
                  <div className="tab-pane fade" id="focus-customer">
                    <ul className="tour-list">
                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>We are not just tour operators.</span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>We are locals of Ladakh.</span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>
                          The roads, the valleys, the culture, the high passes -
                          this is our home. And when you travel with us, you are
                          not just a tourist, you are our guest.
                        </span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>
                          From the peaceful monasteries of Leh to the thrilling
                          heights of Umling La, from the crystal-blue waters of
                          Pangong Lake to the magical sand dunes of Nubra Valley
                          - we design every journey with passion, safety and
                          authenticity.
                        </span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>
                          We specialize in premium and budget tours - whether
                          it's a bike expedition, a comfortable car tour, a
                          honeymoon escape, or a group adventure with friends.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* BOTTOM */}
                <div className="about-content-bottom mt-5">
                  <Link to="/about-us" className="round-btn">
                    More About
                  </Link>

                  <div className="counter-area d-flex align-items-center">
                    <div className="customer-img-grp">
                      <img src={customerImg} alt="customers" />
                    </div>

                    <div className="content ms-2">
                      <div className="number d-flex">
                        <h6 className="counter">500</h6>
                        <span>+</span>
                      </div>
                      <p>Customer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 d-flex justify-content-end">
              <div className="about-img">
                <img
                  src={`${BASE_URL}${activeCMS?.image}`}
                  alt={activeCMS?.title}
                />

                {/* <img src={vectorImg} className="vector" alt="vector" /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative container-fluid car-travel">
        <div className="marquee-car">
          <div className="motodrive-animated-car">
            <img className="car-main" src={leftCar} alt="car" />

            <span className="tyre-1">
              <img src={tyre} alt="tyre" className="spin-tyres" />
            </span>

            <span className="tyre-2">
              <img src={tyre} alt="tyre" className="spin-tyres" />
            </span>
          </div>
        </div>

        <div className="motodrive-right-tree-pic">
          <img src={rightTree} alt="tree" />
        </div>
      </div>
      {/* our-cabs */}
      <section className="home-destination motodrive-section banner-map">
        <div className="flag-img">
          <img src={flagImg} alt="" />
        </div>

        <div className="flag-img-1">
          <img
            className="media-right-ballon move-21 move-2"
            src={carImg2}
            alt=""
          />
        </div>

        <div className="container">
          <div className="row">
            <div
              className="col-lg-8 offset-lg-2 text-center"
              data-aos="fade-up"
            >
              <div className="section-heading">
                <div className="section-title mb-40">
                  <span>Our Cabs</span>
                  <h2>Comfortable Rides Across Ladakh</h2>
                  <img src={ImgAdven} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SLIDER */}
        {homeData?.sliders?.length > 0 && (
          <Swiper
            modules={[EffectCoverflow, Pagination, Autoplay]}
            effect="coverflow"
            centeredSlides={true}
            slidesPerView={3}
            loop={true}
            initialSlide={0}
            onSlideChange={(swiper) => setActiveCarIndex(swiper.realIndex)}
          >
            {homeData.sliders.map((car, index) => (
              <SwiperSlide key={index}>
                <img src={`${BASE_URL}${car.image}`} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        {/* DETAILS */}
        <div className="text-center mx-auto cab">
          <h2>{activeCar?.title}</h2>
          <p>{activeCar?.price}</p>

          <p className="fs-20">
            <b className="text-dark">{activeCar?.details}</b>
          </p>

          <button
            type="button"
            className="round-btn"
            data-bs-toggle="modal"
            data-bs-target="#inquiryModal"
          >
            Book Now
          </button>
        </div>
      </section>
      {/* modal Enquire  */}
      <div
        className="modal fade"
        id="inquiryModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="close" data-bs-dismiss="modal">
                <span>&times;</span>
              </button>

              <h4>Get me a quote</h4>

              <div className="row">
                <h5 className="trip-title">Fixed Car Group Trip</h5>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row enquiry_row">
                  {/* NAME */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="required">Full name</label>
                      <input
                        className="form-control"
                        name="name"
                        placeholder="Your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* PHONE */}
                  <div className="col-md-6">
                    <label className="required">Phone number</label>
                    <div className="row">
                      <div className="col-8">
                        <input
                          type="tel"
                          className="form-control"
                          name="phone"
                          placeholder="9999955555"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* EMAIL */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="required">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="youremail@domain.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* DATE */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Preferred travel date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="travel_date"
                        value={formData.travel_date}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* COMMENTS */}
                  <div className="col-12">
                    <div className="form-group">
                      <label>Additional comments / message</label>
                      <textarea
                        className="form-control"
                        name="comments"
                        rows="3"
                        placeholder="Tell us about your travel plans..."
                        value={formData.comments}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* SUBMIT */}
                  <div className="col-12 text-center mt-3">
                    <button className="btn btn-primary">Submit Inquiry</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>{" "}
      {/* modal Enquire  */}
      <div className="container py-lg-5 py-md-2 py-3">
        <img className="sale" src={bannerSale} alt="" />
      </div>
      {/*destination-tour-package*/}
      <section className="city-section tour-package-1 overflow-hidden">
        <div className="flag-img-1">
          <img src={flagImg} alt="" />
        </div>

        <div className="flag-img">
          <img className="media-left-ballon" src={carImg1} alt="" />
        </div>
      </section>
      {/*why-choose-us-start*/}
      <section className="why-choose">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              {/* TITLE */}
              <div className="section-title mb-40 ">
                <span>Things To DO</span>
                <h2>Adventure Never Ends in Ladakh</h2>

                <img src={ImgAdven} />
              </div>

              <div className="features-grid">
                {features.map((item, index) => (
                  <div className="feature-card" key={index}>
                    <div className="feature-img">
                      <img src={item.img} alt={item.title} />
                    </div>

                    <div className="feature-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 position-relative">
              <div className="blue-bg"></div>

              <div className="car-wrapper">
                <img src={whyImg} alt="car" />
              </div>

              <div className="vertical-text">LADHAK</div>
            </div>
          </div>
        </div>
      </section>
      {/*why-choose-us-end*/}
      {/*tour-experience*/}
      <section className="home-destination  bg-light">
        <div className="flag-img">
          <img src={flagImg} alt="" />
        </div>

        <div className="flag-img-1">
          <img
            className="media-right-ballon move-21 move-2"
            src={carImg2}
            alt=""
          />
        </div>
        <div className="container">
          {/* Heading */}
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-sm-center">
              <div className="section-heading">
                <div className="about-content">
                  <div className="section-title mb-40">
                    <span>Destinations</span>
                    <h2>Explore the Heart of Leh & Ladakh</h2>
                    <img src={ImgAdven} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Cards */}

          <div className="row g-4">
            {homeData?.tours?.map((item, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="package-card">
                  <div className="package-card-img-wrap">
                    <Link className="card-img" to={`/TourDetail/${item.slug}`}>
                      <img src={`${BASE_URL}${item.image}`} alt={item.title} />
                    </Link>

                    <div className="batch">
                      <span className="date">{item.duration}</span>

                      <div className="location">
                        <ul className="location-list">
                          <li>
                            <a>Ladakh</a>
                          </li>

                          <li>
                            <a>{item.tour_type}</a>
                          </li>
                        </ul>
                        <li>
                          <Link to={`/TourDetail/${item.slug}`}>
                            {item.category_name}
                          </Link>
                        </li>
                      </div>
                    </div>
                  </div>

                  <div className="package-card-content">
                    <div className="card-content-top">
                      <h5>
                        <Link to={`/TourDetail/${item.slug}`}>
                          {item.title}
                        </Link>
                      </h5>

                      <div className="location-area">
                        <ul className="location-list scrollTextAni">
                          {item.location?.split("-").map((loc, i) => (
                            <li key={i}>
                              <Link to={`/TourDetail/${item.slug}`}>
                                {loc.trim()}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="card-content-bottom">
                      <div className="price-area">
                        <h6>Starting From:</h6>

                        <span>
                          ₹{item.price} <del>₹{item.mrp}</del>
                        </span>

                        <p>TAXES INCL/PERS</p>
                      </div>

                      <button
                        className="primary-btn2"
                        onClick={() => handleBook(item.slug)}
                      >
                        Book a ride
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/*tour-experience*/}
      {/*HomeCallback-start*/}
      <section
        className="home-callback  bg-img-fullcallback "
        style={{ backgroundImage: `url(${bgImage})` }}
        data-aos="fade"
      >
        <div className="overlay"></div>

        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="callback-content">
                {/* Video Button */}
                <div
                  className="video-button"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <a
                    id="video-container"
                    data-fancybox="video-gallery"
                    href="https://www.youtube.com/watch?v=2OYar8OHEOU"
                  >
                    <i className="fas fa-play"></i>
                  </a>
                </div>

                <h2
                  className="section-title"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  ARE YOU READY TO TRAVEL? REMEMBER US !!
                </h2>

                <p data-aos="fade-up" data-aos-delay="400">
                  Discover the magic of Leh and Ladakh with unforgettable road
                  trips, breathtaking mountain views, and thrilling adventures.
                  LadakhMotodrive offers reliable vehicles, experienced guides,
                  and customized travel experiences to make your journey across
                  the Himalayas safe, comfortable, and truly memorable.
                </p>

                <div
                  className="callback-btn"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <Link
                    to="/premium-ladakh-tour-packages"
                    className="round-btn"
                  >
                    View Packages
                  </Link>

                  <Link
                    to="/about-us"
                    className="outline-btn outline-btn-white"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Counter Section */}
      <div className="home-counter">
        <div className="container">
          <div className="counter-wrap">
            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">3</span>K+
              </span>
              <span className="counter-desc">SATISFIED CUSTOMER</span>
            </div>

            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">10</span>+
              </span>
              <span className="counter-desc">ACTIVE MEMBERS</span>
            </div>

            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">90</span>+
              </span>
              <span className="counter-desc">TOUR DESTINATION</span>
            </div>

            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">10</span>+
              </span>
              <span className="counter-desc">TRAVEL GUIDES</span>
            </div>
          </div>
        </div>
      </div>
      {/*HomeCallback-end*/}
      {/*gallary-section-start*/}
      <section className="home-gallery home-destination">
        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Gallary</span>
                <h2>PHOTO'S FROM TRAVELLERS</h2>
                <img src={ImgAdven} alt="" />
              </div>
            </div>
          </div>
          <LightGallery
            speed={500}
            plugins={[lgThumbnail, lgZoom]}
            elementClassNames="row"
          >
            {galleryData && galleryData.length > 0 ? (
              galleryData.map((item, index) => (
                <a
                  key={index}
                  href={`${BASE_URL}${item.image}`}
                  /* अगर index 6 या उससे ज्यादा है (यानी 7वीं इमेज से), 
           तो उसे स्क्रीन से छुपा दें (d-none), लेकिन HTML में रखें 
        */
                  className={`col-lg-4 mb-4 ${index >= 6 ? "d-none" : ""}`}
                >
                  <img
                    src={`${BASE_URL}${item.image}`}
                    className="lightgallery-box-img img-fluid rounded"
                    alt={`img-${index}`}
                    style={{
                      cursor: "pointer",
                      height: "250px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />

                  {/* अगर आप 6वीं इमेज पर "View All" जैसा ओवरले दिखाना चाहते हैं */}
                  {index === 5 && galleryData.length > 6 && (
                    <div className="view-more-overlay">
                      <span>+{galleryData.length - 6} More</span>
                    </div>
                  )}
                </a>
              ))
            ) : (
              <p className="text-center w-100">Loading Images...</p>
            )}
          </LightGallery>
        </div>
      </section>
      {/*gallary-section-end*/}
      {/*testimonial-sections-start*/}
      <section className="home-testimonial bg-light  home-blog">
        <div className="container">
          {/* Heading */}
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="section-heading">
                <div className="section-title mb-40">
                  <span>CLIENT'S REVIEWS</span>
                </div>

                <h2 className="section-title">
                  TRAVELLER'S TESTIMONIAL
                  <img src={ImgAdven} alt="" />
                </h2>
              </div>
            </div>
          </div>

          {/* Slider */}
          <div className="testimonial-section">
            <Swiper
              modules={[]}
              spaceBetween={30}
              slidesPerView={3}
              autoplay={{ delay: 3000 }}
              loop={true}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {homeData?.reviews?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-item">
                    <div className="testimonial-content">
                      <div className="rating-start-wrap">
                        <div className="rating-start">
                          <span style={{ width: "80%" }}></span>
                        </div>
                      </div>

                      <p>{item.text}</p>

                      <div className="author-content">
                        <figure className="testimonial-img">
                          <img
                            src={`${BASE_URL}${item.image}`}
                            alt={item.name}
                          />
                        </figure>
                        <div className="author-name">
                          <h4>{item.name}</h4>
                          <h6>{item.position}</h6>
                        </div>

                        <div className="author-name">
                          <h5
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                          <span>{item.role}</span>
                        </div>
                      </div>

                      <div className="testimonial-icon">
                        <i className="fas fa-quote-left"></i>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* meta */}
      <section className="home-testimonial bg-light home-blog">
        <div className="container">
          <div className="row mt-4">
            <div className="col-lg-10 offset-lg-1">
              <div className="content-box text-center">
                {/* Short Content */}
                <p className="intro-text">
                  A trip into the Himalayas is an aspiration of most travel
                  lovers. Ladakh MotoDrive can turn this dream of yours into a
                  smooth and unforgettable experience...
                </p>

                {/* FULL CONTENT */}
                {showMore && (
                  <div className="full-content text-start">
                    <p>
                      A trip into the Himalayas is an aspiration of most travel
                      lovers. Ladakh MotoDrive can turn this dream of yours into
                      a smooth and unforgettable experience. We sell our
                      carefully designed Ladakh tour packages incorporating
                      adventure, comfort, and extensive local knowledge. Whether
                      it is about exhilarating mountain adventures or a relaxing
                      break in the midst of nature, our Ladakh tour packages are
                      a great option for travel, tastes, and budget without
                      compromising on quality.
                    </p>

                    <p>
                      Ladakh is a contrasting country, a rugged mountainous
                      region meets calm lakes and silent monasteries, which
                      contrast sharply with dramatic scenery. In every street
                      you drive through, you find a new narrative, a mountain
                      passage, or a forgotten valley untainted by the passage of
                      time. We do not simply offer a trip to Ladakh MotoDrive.
                      We give you experiences that you will remember long after
                      the trip is over. :contentReference[oaicite:0]
                      {/* {(index = 0)} */}
                    </p>

                    <h4>Our Ladakh Tour Options</h4>
                    <p>
                      At Ladakh MotoDrive, we understand that every traveler is
                      unique and has different preferences. That is why we offer
                      several travel options designed to meet each traveller's
                      needs.
                    </p>
                    <ul>
                      <li>
                        Bike Tour: Our bike tours are ideal for travelers who
                        want to experience Ladakh in its raw form.
                      </li>
                      <li>
                        Car Tour: Perfect for families and groups who prefer
                        comfort and safety.
                      </li>
                      <li>
                        Luxury Options: Premium stays, private vehicles, and
                        personalized services.
                      </li>
                    </ul>

                    <h4>Ladakh Tour Packages Cost 2026</h4>
                    <p>
                      The average price of the Ladakh trip per head begins at
                      approximately ₹18,000 and can go up to ₹40,000 or more.
                      For couples, it may range between ₹40,000 and ₹90,000
                      depending on customization.
                    </p>

                    <p>
                      We also offer Ladakh itinerary 5 days and 7 days options.
                      Transportation, accommodation, and permits are managed
                      efficiently by our team.
                    </p>

                    <h4>Popular Destinations in Ladakh</h4>
                    <ul>
                      <li>Leh – Culture, monasteries, and local markets</li>
                      <li>Nubra Valley – Sand dunes and cold desert</li>
                      <li>Khardung La – One of the highest motorable roads</li>
                      <li>Pangong Lake – Changing colors and stunning views</li>
                    </ul>

                    <h4>Best Time to Visit Ladakh</h4>
                    <p>
                      The best time to visit Ladakh is between May and September
                      when roads are open and weather is stable. It is ideal for
                      sightseeing, biking, trekking, and camping.
                    </p>

                    <h4>Why Choose Ladakh MotoDrive?</h4>
                    <ul>
                      <li>Local expert team</li>
                      <li>Transparent pricing</li>
                      <li>Complete trip assistance</li>
                      <li>Customizable itineraries</li>
                    </ul>

                    <h4>FAQs</h4>
                    <p>
                      <b>1. What is the cost of a Ladakh trip?</b>
                      <br />
                      ₹18,000 to ₹90,000 depending on package type.
                    </p>

                    <p>
                      <b>2. Best time to visit?</b>
                      <br />
                      May to September.
                    </p>

                    <p>
                      <b>3. Bike or car?</b>
                      <br />
                      Bike = adventure, Car = comfort.
                    </p>

                    <p>
                      <b>4. Ideal duration?</b>
                      <br />5 to 7 days.
                    </p>

                    <p>
                      <b>5. Family trip?</b>
                      <br />
                      Yes, with proper planning and car packages.
                    </p>
                  </div>
                )}

                {/* Button */}
                <button
                  className="read-btn"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? "Read Less ↑" : "Read More ↓"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*testimonial-section-end*/}
      {/*faq-section-start*/}
      <section className="faq-section">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT SIDE */}
            <div className="col-lg-6">
              {/* TITLE */}
              <div className="section-title mb-40">
                <span>Faq's</span>
                <h2> General Frequently Asked Questions</h2>

                <img src={ImgAdven} alt="" />
              </div>
              <span className="faq-badge"></span>
              <div className="faq-image">
                <img className="media-girl" src={carImg} alt="car" />
                <img className="media-left-ballon" src={carImg1} alt="car" />
                <img className="media-right-ballon" src={carImg2} alt="car" />
                <img className="media-cloud1" src={carImg3} alt="car" />
                <img className="media-cloud2" src={carImg4} alt="car" />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-6">
              <div className="faq-accordion">
                {homeData?.faq?.map((faq, index) => (
                  <div
                    key={index}
                    className={`faq-item ${
                      activeFaqIndex === index ? "active" : ""
                    }`}
                  >
                    <div
                      className="faq-question"
                      onClick={() => toggleFAQ(index)}
                    >
                      <span className="icon">?</span>
                      <h5>{faq.title}</h5>
                      <span className="arrow">
                        {activeFaqIndex === index ? "▲" : "▼"}
                      </span>
                    </div>

                    {activeFaqIndex === index && (
                      <div className="faq-answer">
                        {/* <p>{faq.description}</p> */}
                        <h5
                          dangerouslySetInnerHTML={{
                            __html: faq.description,
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*faq-section-end*/}
    </>
  );
};

export default Home;
